var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { EField } from "@rentiohq/shared-frontend/dist/forms/createContract/schema.createContract.types";
import { getFieldTitle } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EContractCostsAreIndexable, EContractCostsPriceType, VAT_OPTIONS, VAT_OPTIONS_BOOKKEEPING, } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { isNumber } from "lodash";
import { useState, useEffect } from "react";
import { Button } from "../../../Button";
import { Grid } from "../../../Grid/Grid";
import { Label } from "../../../Labelled";
import { SegmentedControl } from "../../../SegmentedControl";
import { Select } from "../../../Select";
import { Stack } from "../../../Stack";
import { TextField } from "../../../TextField/TextField";
import { NumberInput } from "../NumberField/components/NumberInput";
import * as S from "./AdditionalCost.styled";
import { EAdditionalCostField } from "./AdditionalCost.types";
import { getAdditionalCostsKey, getFieldKey, getInitialCount, getValue, getInitialCost,
// getInitialDescription,
 } from "./AdditionalCost.utils";
export var AdditionalCosts = function (props) {
    var _a;
    var name = props.name, onChange = props.onChange, formData = props.formData, formContext = props.formContext, uiSchema = props.uiSchema, idSchema = props.idSchema, disabled = props.disabled, title = props.title, required = props.required, rawErrors = props.rawErrors, rest = __rest(props, ["name", "onChange", "formData", "formContext", "uiSchema", "idSchema", "disabled", "title", "required", "rawErrors"]);
    var fieldTitle = getFieldTitle(uiSchema, formContext);
    var allFormData = formContext.getAllFormData();
    var _b = useState(formData || {}), localFormData = _b[0], setLocalFormData = _b[1];
    var _c = useState(getInitialCount(allFormData, "additionalCostsInitial")), addedAdditionalCostsCount = _c[0], setAddedAdditionalCostsCount = _c[1];
    var _d = useState([]), savedCosts = _d[0], setSavedCosts = _d[1];
    var _e = useState({}), validationErrors = _e[0], setValidationErrors = _e[1];
    useEffect(function () {
        setLocalFormData(formData);
    }, [formData]);
    var isDisabled = uiSchema.isDisabled, buttonTitle = uiSchema.buttonTitle, isExistingContract = uiSchema.isExisting, showStartPrice = uiSchema.showStartPrice, bookkeepingEnabled = uiSchema.bookkeepingEnabled;
    var isExisting = (isExistingContract === null || isExistingContract === void 0 ? void 0 : isExistingContract(allFormData)) || false;
    var uiDisabled = isDisabled
        ? isDisabled(formContext.getAllFormData())
        : undefined;
    var validateSection = function (sectionKey, isExisting, data) {
        var _a, _b, _c;
        var errors = {};
        var section = (data === null || data === void 0 ? void 0 : data[sectionKey]) || {};
        var initialData = allFormData[EField.AdditionalCostsInitial];
        var hasInitialData = initialData && ((_a = Object.keys(initialData)) === null || _a === void 0 ? void 0 : _a.length) > 0;
        var hasSectionInInitialData = hasInitialData && allFormData[EField.AdditionalCostsInitial][sectionKey];
        if (!((_b = section.description) === null || _b === void 0 ? void 0 : _b.trim())) {
            errors.description = getLocalizedText("contract_info.description.required");
        }
        if (((_c = section.description) === null || _c === void 0 ? void 0 : _c.trim()) &&
            hasInitialData &&
            hasSectionInInitialData) {
            if (name === EField.AdditionalCostsCurrent &&
                section.description !==
                    allFormData[EField.AdditionalCostsInitial][sectionKey].description) {
                errors.description = getLocalizedText("contract_info.description_mismatch.required");
            }
        }
        if (!showStartPrice && !section.currentPrice) {
            errors.currentPrice = getLocalizedText("contract_info.current_price.required");
        }
        if (showStartPrice && !section.startPrice) {
            errors.startPrice = getLocalizedText("contract_info.start_price.required");
        }
        if (section.priceVat == null) {
            errors.priceVat = getLocalizedText("contract_info.vat_amount.required");
        }
        return errors;
    };
    var handleFieldChange = function (sectionKey, fieldKey, value) {
        var _a, _b;
        var newState = __assign(__assign({}, localFormData), (_a = {}, _a[sectionKey] = __assign(__assign({}, localFormData[sectionKey]), (_b = {}, _b[fieldKey] = value, _b)), _a));
        setLocalFormData(newState);
        setValidationErrors(function (prev) {
            var _a;
            var sectionErrors = __assign({}, prev[sectionKey]);
            delete sectionErrors[fieldKey];
            return __assign(__assign({}, prev), (_a = {}, _a[sectionKey] = sectionErrors, _a));
        });
    };
    var handleSaveSection = function (sectionKey) {
        var errors = validateSection(sectionKey, isExisting, localFormData);
        if (Object.keys(errors).length > 0) {
            setValidationErrors(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[sectionKey] = errors, _a)));
            });
        }
        else {
            onChange(localFormData);
            setSavedCosts(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [sectionKey], false); });
            setValidationErrors(function (prev) {
                var updated = __assign({}, prev);
                delete updated[sectionKey];
                return updated;
            });
        }
    };
    var handleDeleteSection = function (key) {
        setSavedCosts(function (prevState) {
            return prevState.filter(function (sectionKey) { return sectionKey !== key; });
        });
        var state = __assign({}, localFormData);
        delete state[key];
        setLocalFormData(state);
        onChange(state);
    };
    return (_jsxs(_Fragment, { children: [Boolean(localFormData && ((_a = Object.keys(localFormData)) === null || _a === void 0 ? void 0 : _a.length)) && (_jsx(Stack, { vertical: true, spacing: "base", children: Object.keys(localFormData).map(function (sectionKey, index) {
                    var _a, _b, _c, _d;
                    var isSaved = disabled || savedCosts.includes(sectionKey);
                    var hasStartPrice = !!getInitialCost({
                        sectionKey: sectionKey,
                        formData: localFormData,
                    });
                    // const hasStartDescription = !!getInitialDescription({
                    //   sectionKey,
                    //   formData: localFormData,
                    // });
                    var hasExistingStartPrice = isExisting && hasStartPrice;
                    return (_jsxs(S.FormWrapper, { isLatest: !isSaved, children: [_jsx(S.Title, { children: "".concat(index + 1, ": ").concat(fieldTitle) }), _jsxs(Grid, { children: [_jsx(Grid.Item, { width: [1, 1], children: _jsx(TextField, { name: getFieldKey({
                                                sectionKey: sectionKey,
                                                fieldKey: EAdditionalCostField.Description,
                                            }), error: (_a = validationErrors[sectionKey]) === null || _a === void 0 ? void 0 : _a.description, value: getValue({
                                                sectionKey: sectionKey,
                                                fieldKey: EAdditionalCostField.Description,
                                                formData: localFormData,
                                            }), label: getLocalizedText("contract_info.description.title"), disabled: isSaved, onChange: function (_a) {
                                                var target = _a.target;
                                                handleFieldChange(sectionKey, EAdditionalCostField.Description, target.value);
                                            } }) }), showStartPrice ? (_jsx(Grid.Item, { width: [1, 1 / 2], children: _jsx(NumberInput, __assign({ name: getFieldKey({
                                                sectionKey: sectionKey,
                                                fieldKey: EAdditionalCostField.StartPrice,
                                            }), rawErrors: [(_b = validationErrors[sectionKey]) === null || _b === void 0 ? void 0 : _b.startPrice], formData: getValue({
                                                sectionKey: sectionKey,
                                                fieldKey: EAdditionalCostField.StartPrice,
                                                formData: localFormData,
                                            }), title: getLocalizedText("contract_info.start_price.title"), disabled: isSaved, uiSchema: __assign(__assign({}, uiSchema), { placeholder: "0", suffixText: "EUR", isFloat: true, decimals: CONFIG.DECIMALS_FOR_CURRENCY }), idSchema: idSchema, formContext: formContext, onChange: function (value) {
                                                handleFieldChange(sectionKey, EAdditionalCostField.StartPrice, value);
                                            }, required: true }, rest)) })) : (_jsx(Grid.Item, { width: [1, 1 / 2], children: _jsx(NumberInput, __assign({ name: getFieldKey({
                                                sectionKey: sectionKey,
                                                fieldKey: EAdditionalCostField.CurrentPrice,
                                            }), rawErrors: [(_c = validationErrors[sectionKey]) === null || _c === void 0 ? void 0 : _c.currentPrice], formData: getValue({
                                                sectionKey: sectionKey,
                                                fieldKey: EAdditionalCostField.CurrentPrice,
                                                formData: localFormData,
                                            }), title: getLocalizedText("contract_info.current_price.title"), disabled: isSaved, uiSchema: __assign(__assign({}, uiSchema), { placeholder: "0", suffixText: "EUR", isFloat: true, decimals: CONFIG.DECIMALS_FOR_CURRENCY }), idSchema: idSchema, formContext: formContext, onChange: function (value) {
                                                handleFieldChange(sectionKey, EAdditionalCostField.CurrentPrice, value);
                                            }, required: true }, rest)) })), _jsx(Grid.Item, { width: [1, 1 / 2], children: _jsx(Select, { id: getFieldKey({
                                                sectionKey: sectionKey,
                                                fieldKey: EAdditionalCostField.PriceVat,
                                            }), name: getFieldKey({
                                                sectionKey: sectionKey,
                                                fieldKey: EAdditionalCostField.PriceVat,
                                            }), value: getValue({
                                                sectionKey: sectionKey,
                                                fieldKey: EAdditionalCostField.PriceVat,
                                                formData: localFormData,
                                            }), disabled: hasExistingStartPrice || isSaved, label: getLocalizedText("contract_info.vat_amount.title"), error: (_d = validationErrors[sectionKey]) === null || _d === void 0 ? void 0 : _d.priceVat, options: (bookkeepingEnabled
                                                ? VAT_OPTIONS_BOOKKEEPING
                                                : VAT_OPTIONS).map(function (id) {
                                                if (isNumber(id)) {
                                                    return {
                                                        value: id,
                                                        id: id,
                                                        label: getLocalizedText("contract.item.vat", { value: "".concat(id) }, id),
                                                    };
                                                }
                                                return {
                                                    value: id,
                                                    id: id,
                                                    label: getLocalizedText("contract.item.no_vat_type.".concat(id).toLowerCase()),
                                                };
                                            }), onChange: function (_a) {
                                                var value = _a.value;
                                                handleFieldChange(sectionKey, EAdditionalCostField.PriceVat, value);
                                            } }) }), _jsxs(Grid.Item, { width: [1, 1 / 2], children: [_jsx(Label, { children: getLocalizedText("contract_info.non_common_costs.price_type.label") }), _jsx(S.InputWrapper, { children: _jsx(SegmentedControl, { name: getFieldKey({
                                                        sectionKey: sectionKey,
                                                        fieldKey: EAdditionalCostField.PriceType,
                                                    }), selected: getValue({
                                                        sectionKey: sectionKey,
                                                        fieldKey: EAdditionalCostField.PriceType,
                                                        formData: localFormData,
                                                    }) || EContractCostsPriceType.Fixed, disabled: hasExistingStartPrice || isSaved, options: [
                                                        EContractCostsPriceType.Fixed,
                                                        EContractCostsPriceType.Provision,
                                                    ].map(function (id) { return ({
                                                        id: id,
                                                        value: getLocalizedText("contract_info.costs.price_type.value.".concat(id.toLowerCase())),
                                                    }); }), onChange: function (value) {
                                                        handleFieldChange(sectionKey, EAdditionalCostField.PriceType, value);
                                                    } }) })] }), _jsxs(Grid.Item, { width: [1, 1 / 2], children: [_jsx(Label, { children: getLocalizedText("contract_info.non_common_costs.are_indexable.label") }), _jsx(S.InputWrapper, { children: _jsx(SegmentedControl, { name: getFieldKey({
                                                        sectionKey: sectionKey,
                                                        fieldKey: EAdditionalCostField.IsIndexable,
                                                    }), selected: getValue({
                                                        sectionKey: sectionKey,
                                                        fieldKey: EAdditionalCostField.IsIndexable,
                                                        formData: localFormData,
                                                    }) || EContractCostsAreIndexable.No, options: [
                                                        EContractCostsAreIndexable.Yes,
                                                        EContractCostsAreIndexable.No,
                                                    ].map(function (id) { return ({
                                                        id: id,
                                                        value: getLocalizedText("contract_info.costs.are_indexable.value.".concat(id.toLowerCase())),
                                                    }); }), disabled: hasExistingStartPrice || isSaved, onChange: function (value) {
                                                        handleFieldChange(sectionKey, EAdditionalCostField.IsIndexable, value);
                                                    } }) })] }), _jsx(Grid.Item, { width: 1, children: _jsxs(Stack, { spacing: "base", children: [!isSaved && (_jsx(Button, { appearance: "primary", onClick: function () { return handleSaveSection(sectionKey); }, children: getLocalizedText("system.save") })), _jsx(Button, { appearance: "danger", onClick: function () { return handleDeleteSection(sectionKey); }, children: getLocalizedText("system.delete") })] }) })] })] }, sectionKey));
                }) })), _jsx(Button, { isDisabled: uiDisabled, appearance: "outline", onClick: function () {
                    var _a;
                    var newKey = getAdditionalCostsKey(addedAdditionalCostsCount + 1);
                    setLocalFormData(__assign(__assign({}, localFormData), (_a = {}, _a[newKey] = {}, _a)));
                    setAddedAdditionalCostsCount(addedAdditionalCostsCount + 1);
                }, children: buttonTitle })] }));
};
